import React from 'react';
import { Box } from '@mui/material';
import { useLogin } from '../../components/login/useLogin';
import LoginBranding from '../../components/login/LoginBranding';
import LoginForm from '../../components/login/LoginForm';
import './LoginPage.scss';

const LoginPage: React.FC = () => {
  const {
    formData,
    formErrors,
    showPassword,
    isLoading,
    error,
    handleInputChange,
    handleSubmit,
    togglePasswordVisibility,
    handleForgotPassword,
  } = useLogin();

  return (
    <Box className="login-page">
      <Box className="login-page__left">
        <LoginBranding />
      </Box>

      <Box className="login-page__right">
        <LoginForm
          formData={formData}
          formErrors={formErrors}
          showPassword={showPassword}
          isLoading={isLoading}
          error={error}
          onInputChange={handleInputChange}
          onSubmit={handleSubmit}
          onTogglePassword={togglePasswordVisibility}
          onForgotPassword={handleForgotPassword}
        />
      </Box>
    </Box>
  );
};

export default LoginPage;
